'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _type = require('./type');

var decorate = function decorate(func, opts) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var before = opts.before,
        after = opts.after;


    if (_type.is.func(before)) before.apply(null, args);

    var result = func.apply(null, args);

    if (_type.is.func(after)) after.call(null, result);

    return result;
  };
};

exports.default = decorate;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL21vZHVsZXMvdXRpbHMvZGVjb3JhdGUuanMiXSwibmFtZXMiOlsiZGVjb3JhdGUiLCJmdW5jIiwib3B0cyIsImFyZ3MiLCJiZWZvcmUiLCJhZnRlciIsImlzIiwiYXBwbHkiLCJyZXN1bHQiLCJjYWxsIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7QUFFQSxJQUFNQSxXQUFXLFNBQVhBLFFBQVcsQ0FBQ0MsSUFBRCxFQUFPQyxJQUFQO0FBQUEsU0FBZ0IsWUFBYTtBQUFBLHNDQUFUQyxJQUFTO0FBQVRBLFVBQVM7QUFBQTs7QUFBQSxRQUNwQ0MsTUFEb0MsR0FDbEJGLElBRGtCLENBQ3BDRSxNQURvQztBQUFBLFFBQzVCQyxLQUQ0QixHQUNsQkgsSUFEa0IsQ0FDNUJHLEtBRDRCOzs7QUFHNUMsUUFBSUMsU0FBR0wsSUFBSCxDQUFRRyxNQUFSLENBQUosRUFBcUJBLE9BQU9HLEtBQVAsQ0FBYSxJQUFiLEVBQW1CSixJQUFuQjs7QUFFckIsUUFBTUssU0FBU1AsS0FBS00sS0FBTCxDQUFXLElBQVgsRUFBaUJKLElBQWpCLENBQWY7O0FBRUEsUUFBSUcsU0FBR0wsSUFBSCxDQUFRSSxLQUFSLENBQUosRUFBb0JBLE1BQU1JLElBQU4sQ0FBVyxJQUFYLEVBQWlCRCxNQUFqQjs7QUFFcEIsV0FBT0EsTUFBUDtBQUNELEdBVmdCO0FBQUEsQ0FBakI7O2tCQVllUixRIiwiZmlsZSI6ImRlY29yYXRlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgaXMgfSBmcm9tICcuL3R5cGUnXG5cbmNvbnN0IGRlY29yYXRlID0gKGZ1bmMsIG9wdHMpID0+ICguLi5hcmdzKSA9PiB7XG4gIGNvbnN0IHsgYmVmb3JlLCBhZnRlciB9ID0gb3B0c1xuXG4gIGlmIChpcy5mdW5jKGJlZm9yZSkpIGJlZm9yZS5hcHBseShudWxsLCBhcmdzKVxuXG4gIGNvbnN0IHJlc3VsdCA9IGZ1bmMuYXBwbHkobnVsbCwgYXJncylcblxuICBpZiAoaXMuZnVuYyhhZnRlcikpIGFmdGVyLmNhbGwobnVsbCwgcmVzdWx0KVxuXG4gIHJldHVybiByZXN1bHRcbn1cblxuZXhwb3J0IGRlZmF1bHQgZGVjb3JhdGVcbiJdfQ==